import { LayoutWrapper } from 'components/common';
import { Navbar, NavbarProps } from 'components/Navbar/NavBar';
import React, { useMemo } from 'react';

interface Props {
  children: React.ReactNode;
  navbar?: Pick<NavbarProps, 'logo' | 'title' | 'dropdowns'>;
  noReleaseNotes?: boolean;
}

export const DefaultLayout = ({ children, noReleaseNotes, navbar }: Props) => {
  const releaseNote: NavbarProps['releaseNote'] = useMemo(() => {
    if (noReleaseNotes) {
      return undefined;
    } else {
      return {
        key: 'STAFF',
        to: '/staff/release-notes',
      };
    }
  }, [noReleaseNotes]);
  return (
    <LayoutWrapper>
      <Navbar {...navbar} releaseNote={releaseNote} />
      {children}
    </LayoutWrapper>
  );
};
